<template>
    <div class="mak-map">
        <el-row class="mak-map-header">
            <el-button type="primary" icon="el-icon-location" @click="geolocate" style="margin-right: 10px"/>
            <a :href="link" target="_blank">
                <el-button type="primary" icon="el-icon-share" :disabled="!link">Adres Linki</el-button>
            </a>
        </el-row>

        <!-- Map -->
        <googlemaps-map
                ref="map"
                :center.sync="center"
                :zoom.sync="zoom">

            <!-- User Position -->
<!--            <googlemaps-user-position-->
<!--                    @update:position="setUserPosition" />-->

            <!-- Marker -->
            <googlemaps-marker
                    v-if="marker"
                    title="Paris"
                    :draggable="true"
                    :position.sync="marker.position" @dragend="setPosition"/>

        </googlemaps-map>

        <el-row class="mak-map-footer">
            <el-button type="success" icon="el-icon-check">Bu adresi kullan</el-button>
        </el-row>

    </div>
</template>

<script>

    export default {
        name: 'mak-map',
        data() {
            return {
                options: {
                },
                userPosition: {
                    lat: 39.925533,
                    lng: 32.866287
                },
                zoom: 12,
                center: { lat: 39.925533, lng: 32.866287 },
            };
        },
        computed: {
            link() {
                if (!this.userPosition) {
                    return;
                }
                const lat = this.userPosition.lat;
                const lng = this.userPosition.lng;
                return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
            },
            marker() {
                return {
                    position: this.userPosition,
                };
            },
        },
        methods: {
            centerOnUser () {
                if (this.userPosition) {
                    this.center = this.userPosition
                }
            },
            setUserPosition (position) {
                // console.warn('pos', position)
                this.userPosition = position;
                this.centerOnUser();
            },
            setPosition (position) {
                //console.warn('possss', position, position.latLng.lat(), position.latLng.lng())
                this.userPosition = {
                    lat: position.latLng.lat(),
                    lng: position.latLng.lng(),
                };
            },
            geolocate: function() {
                navigator.geolocation.getCurrentPosition(position => {
                    this.userPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    setTimeout(() => {
                        this.centerOnUser();
                    }, 300)
                });
            },
        },
        mounted() {
            this.geolocate();
        },
    }
</script>

<style lang="scss" scoped>
    .mak-map {
        height: 100%;
        display: flex;
        flex-direction: column;
        height: 500px;

        .mak-map-header {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            margin: 10px 20px;
        }


        .mak-map-footer {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin: 10px 20px;

            .el-button {
                width: 100%;
            }
        }

        .vue-google-map {
            flex: 100% 1 1;
        }
    }
</style>
